// random-products.js

function initializeRandomProducts() {
  // Function to shuffle array randomly
  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  // Process all random product containers
  const productContainers = document.querySelectorAll('.random-products-container');

  if (productContainers.length === 0) {
    // If no containers found, try again after a short delay
    setTimeout(initializeRandomProducts, 100);
    return;
  }

  productContainers.forEach(container => {
    const productsToShow = parseInt(container.getAttribute('data-products-to-show')) || 4;
    const productItems = container.querySelectorAll('.product-item');

    if (productItems.length === 0) {
      // If no products found, try again after a short delay
      setTimeout(() => initializeRandomProducts(), 100);
      return;
    }

    if (productItems.length > productsToShow) {
      const productsArray = Array.from(productItems);
      const shuffledProducts = shuffleArray(productsArray);

      productItems.forEach(item => item.style.display = 'none');

      for (let i = 0; i < productsToShow && i < shuffledProducts.length; i++) {
        shuffledProducts[i].style.display = 'block';
      }
    } else {
      productItems.forEach(item => item.style.display = 'block');
    }
  });
}

// Run on initial page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeRandomProducts);
} else {
  setTimeout(initializeRandomProducts, 50);
}

// Run on Shopify section AJAX load
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.random-products-container')) {
      setTimeout(initializeRandomProducts, 50);
    }
  });
}
